export function formatRelativeTime(value: string) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value

  const diffMs = Date.now() - date.getTime()
  const minutes = Math.floor(diffMs / (1000 * 60))
  if (minutes < 1) return '刚刚'
  if (minutes < 60) return `${minutes}分钟前`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}小时前`

  const startOfToday = new Date()
  startOfToday.setHours(0, 0, 0, 0)
  const startOfYesterday = new Date(startOfToday)
  startOfYesterday.setDate(startOfYesterday.getDate() - 1)
  if (date >= startOfYesterday && date < startOfToday) return '昨天'

  const days = Math.floor(hours / 24)
  if (days < 7) return `${days}天前`
  return `${date.getMonth() + 1}月${date.getDate()}日`
}

export function formatDateTime(value: string) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getMonth() + 1}月${date.getDate()}日 ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

const TIME_GAP_MS = 5 * 60 * 1000

export function shouldShowMessageTime(prev?: string, current?: string) {
  if (!current) return false
  if (!prev) return true
  const prevTime = new Date(prev).getTime()
  const currentTime = new Date(current).getTime()
  if (Number.isNaN(prevTime) || Number.isNaN(currentTime)) return true
  return Math.abs(currentTime - prevTime) >= TIME_GAP_MS
}

export function formatMessagePreview(message: {
  kind: 'text' | 'image' | 'file' | 'card'
  content: string
  fileName?: string
}) {
  if (message.kind === 'image') return '[图片]'
  if (message.kind === 'file') return `[文件] ${message.fileName || message.content}`
  if (message.kind === 'card') return message.fileName || message.content || '[卡片]'
  const text = message.content.replace(/\s+/g, ' ').trim()
  return text.length > 36 ? `${text.slice(0, 36)}…` : text
}

export function formatPayloadValue(value: unknown) {
  if (value == null) return '—'
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }
  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}
